module.exports = __webpack_public_path__ + "img/contact-logo.c3c59dcc.png";